import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/ExperienceNew'
import AIPlayground from './components/playground/AIPlayground'
import Testimonials from './components/testimonials/Testimonials'
import Contant from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
  return (
    <>
        <Header />
        <Nav />
        <About />
        <Experience />
        <AIPlayground />
        <Testimonials />
        <Contant />
        <Footer />
    </>
  )
}

export default App